import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../contexts/ThemeContext';
import { servicesData } from '../../data/servicesData';
import SingleService from './SingleService/SingleService';
import './Services.css';

function Services() {
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();

    return (
        <section className="svc-section" id="services">
            {/* هدر بخش */}
            <div className="svc-header">
                <h2 className="svc-header__title">چه خدماتی ارائه می‌دهیم؟</h2>
                <p className="svc-header__sub">
                    با بهترین پزشکان، برندها و مراکز زیبایی کشور همراه شوید
                </p>
                <div className="svc-header__line" style={{ background: theme.primary }} />
            </div>

            {/* کارت‌ها */}
            <div className="svc-grid">
                {servicesData.map((service) => (
                    <SingleService
                        key={service.id}
                        service={service}
                        onClick={() => navigate(`/service/${service.id}`)}
                    />
                ))}
            </div>
        </section>
    );
}

export default Services;
